// extracted by mini-css-extract-plugin
export var md = "_redotech-redo-web-lib-arbiter-components-toggle-redo-toggle-md";
export var semantic = "_redotech-redo-web-lib-arbiter-components-toggle-redo-toggle-semantic";
export var sm = "_redotech-redo-web-lib-arbiter-components-toggle-redo-toggle-sm";
export var text = "_redotech-redo-web-lib-arbiter-components-toggle-redo-toggle-text";
export var toggleInput = "_redotech-redo-web-lib-arbiter-components-toggle-redo-toggle-toggle-input";
export var toggleSwitch = "_redotech-redo-web-lib-arbiter-components-toggle-redo-toggle-toggle-switch";
export var xs = "_redotech-redo-web-lib-arbiter-components-toggle-redo-toggle-xs";